
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TurnBackgroundBlackComponent } from "../preauth_portal/components/CommonComponents"
import Button from "../main_portal_v2/components/common_components/Button"

// API Calls
import MeetingsAPI from "../preauth_portal/api/api_calls/MeetingsAPI";
import CenteredLoadingIcon from "../main_portal/components/CenteredLoadingIcon";

function JoinMeetingContent(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const [missionName, setMissionName] = useState("");
    const [startTime, setStartTime] = useState(new Date());
    const [formattedStartTime, setFormattedStartTime] = useState("");
    const [endTime, setEndTime] = useState(new Date());
    const [timeUntilString, setTimeUntilString] = useState("");
    const [meetingLink, setMeetingLink] = useState("");
    const [changeLink, setChangeLink] = useState("/");
    const [meetingLoaded, setMeetingLoaded] = useState(false);
    const [meetingExists, setMeetingExists] = useState(false);
    const [inProgressMeeting, setInProgressMeeting] = useState(false);
    const [now, setNow] = useState(new Date());

    // New requirements section.
    const [deviceRequirement, setDeviceRequirement] = useState("");
    const [requireWalletUsage, setRequireWalletUsage] = useState(false);
    const [requireShareScreen, setRequireShareScreen] = useState(false);
    const [requireVideo, setRequireVideo] = useState(false);
    const [viewUserWallets, setViewUserWallets] = useState(false);

    const slug = location.pathname.split("/").pop();

    useEffect(() => {
        async function GetMeeting(width, height, slug) {
            const data = await MeetingsAPI.show_user({ device_width: width, device_height: height, meeting_slug: slug, handleRedirect: navigate });

            if (data.success) {
                setMissionName(data.mission_name);
                setStartTime(data.start_time);
                setFormattedStartTime(data.formatted_start_time);
                setEndTime(data.end_time);
                setTimeUntilString(data.time_until_string);
                setMeetingLink(data.meeting_link);
                setChangeLink(data.change_link);
                setInProgressMeeting(data.in_progress);
                setDeviceRequirement(data.device_requirement);
                setRequireWalletUsage(data.require_wallet_usage);
                setRequireShareScreen(data.require_share_screen);
                setRequireVideo(data.require_video);
                setViewUserWallets(data.view_user_wallets);
                setMeetingExists(true);
                setMeetingLoaded(true);
            } else {
                setMissionName("Mission Not Found");
                setMeetingExists(false);
                setMeetingLoaded(true);
            }
        }

        const width = window.screen.width;
        const height = window.screen.height;

        GetMeeting(width, height, slug);
    }, []);

    // Reload the page 10 minutes before the meeting starts
    useEffect(() => {
        const meetingTime = new Date(startTime).getTime();
        const now = Date.now();
        const tenMinutesBeforeMeeting = meetingTime - 10 * 60 * 1000;
        const timeUntilReload = tenMinutesBeforeMeeting - now;

        if (timeUntilReload > 0) {
            const timeoutId = setTimeout(() => {
                window.location.reload();
            }, timeUntilReload);

            return () => clearTimeout(timeoutId);
        }
    }, [startTime]);

    // tick exactly at each minute boundary plus one secondso the minute label flips on time
    useEffect(() => {
        let intervalId;
        const startAlignedInterval = () => {
            // kick an immediate update (optional)
            setNow(Date.now());
            intervalId = setInterval(() => setNow(Date.now()), 60_000);
        };
        const msToNextMinute = 60_000 - (Date.now() % 60_000) + 1000;
        const timeoutId = setTimeout(startAlignedInterval, msToNextMinute);

        return () => {
            clearTimeout(timeoutId);
            if (intervalId) clearInterval(intervalId);
        };
    }, []);

    function SessionCard() {
        const startMs = new Date(startTime).getTime();
        const endMs = new Date(endTime).getTime();
        const diffMs = startMs - now;

        const withinTenMinutes = diffMs > 0 && diffMs <= 10 * 60 * 1000;
        const displayTimeUntil = timeUntilHelper(diffMs); // your Ruby-equivalent helper

        const computedInProgress =
            Number.isFinite(startMs) &&
            Number.isFinite(endMs) &&
            now >= startMs &&
            now <= endMs;

        const showInProgress = computedInProgress || inProgressMeeting;

        if (!meetingLoaded) {
            return <LoadingSession />;
        } else if (meetingExists) {
            if (showInProgress) {
                return <InProgressSession missionName={missionName} formattedStartTime={formattedStartTime} meetingLink={meetingLink} changeLink={changeLink} deviceRequirement={deviceRequirement} requireWalletUsage={requireWalletUsage} requireShareScreen={requireShareScreen} requireVideo={requireVideo} viewUserWallets={viewUserWallets} />;
            } else if (displayTimeUntil === null) {
                return <PastSession missionName={missionName} formattedStartTime={formattedStartTime} />;
            } else if (withinTenMinutes) {
                return <ImminentSession missionName={missionName} formattedStartTime={formattedStartTime} timeUntilString={displayTimeUntil} meetingLink={meetingLink} changeLink={changeLink} deviceRequirement={deviceRequirement} requireWalletUsage={requireWalletUsage} requireShareScreen={requireShareScreen} requireVideo={requireVideo} viewUserWallets={viewUserWallets} />;
            } else {
                return <UpcomingSession missionName={missionName} formattedStartTime={formattedStartTime} timeUntilString={displayTimeUntil} changeLink={changeLink} deviceRequirement={deviceRequirement} requireWalletUsage={requireWalletUsage} requireShareScreen={requireShareScreen} requireVideo={requireVideo} viewUserWallets={viewUserWallets} />;
            }
        } else {
            return <NotFoundSession />;
        }
    }

    return (
        <div className="container-fluid bg-black-color">
            <div className='row d-flex justify-content-center align-items-center h-100'>
                <TurnBackgroundBlackComponent />
                <SessionCard />
            </div>
        </div>
    );
}

function MeetingCard({ preTitle, title, date, timeSummaryStart, timeSummaryEnd, bodyText, buttonText, buttonAction, changeLink, deviceRequirement, requireWalletUsage, requireShareScreen, requireVideo, viewUserWallets }) {


    var failsMobile = false;
    var failsDesktop = false;
    const notices = [];
    if (deviceRequirement == "mobile") {
        notices.push(
            <li key="mobile" className="meeting-join-card-notice-text">Join via a <span className="meeting-join-card-notice-highlight">mobile device</span></li>
        );
        if (window.innerWidth > 768) {
            failsMobile = true;
        }
    }
    if (deviceRequirement == "desktop") {
        notices.push(
            <li key="desktop" className="meeting-join-card-notice-text">Join via a <span className="meeting-join-card-notice-highlight">desktop device</span></li>
        );
        if (window.innerWidth <= 768) {
            failsDesktop = true;
        }
    }
    if (requireWalletUsage) {
        notices.push(
            <li key="wallet" className="meeting-join-card-notice-text">You will be asked to <span className="meeting-join-card-notice-highlight">connect your wallet</span></li>
        );
    }
    if (requireShareScreen) {
        notices.push(
            <li key="share" className="meeting-join-card-notice-text">You will be asked to <span className="meeting-join-card-notice-highlight">share your screen</span></li>
        );
    }
    if (requireVideo) {
        notices.push(
            <li key="video" className="meeting-join-card-notice-text">Turn on <span className="meeting-join-card-notice-highlight">your video</span></li>
        );
    }
    const showNotices = notices.length > 0;

    return (
        <div className="meeting-join-container">
            <div className={"meeting-join-card" + (showNotices ? " meeting-join-card-small-gap" : "")}>
                <div className="meeting-join-card-header">
                    <div className="meeting-join-card-header-title-section">
                        <div className="meeting-join-card-header-pre-title">
                            {preTitle}
                        </div>
                        <div className="meeting-join-card-header-title">
                            {title}
                        </div>
                    </div>
                    <div className="meeting-join-card-timing-section">
                        <div className="meeting-join-card-date">
                            {date}
                        </div>
                        <div className="meeting-join-card-time-summary">
                            {timeSummaryStart} <span className="meeting-join-card-time-highlight">{timeSummaryEnd} </span>
                        </div>
                    </div>
                </div>
                {showNotices && (
                    <div className="meeting-join-card-notices-container">
                        <div className="meeting-join-card-notices-title">
                            Reminders:
                        </div>
                        <div className="meeting-join-card-notices">
                            <ul className="meeting-join-card-notices-list">
                                {notices}
                            </ul>
                        </div>
                    </div>
                )}
                <div className="meeting-join-card-body">
                    {buttonText && buttonAction && (
                        <div className="button-holder">
                            <Button onClick={buttonAction} disabled={failsMobile || failsDesktop} size="medium" color="primary" fullWidth={true} >
                                {buttonText}
                            </Button>
                        </div>
                    )}
                    <div className="meeting-join-card-body-text">
                        {failsMobile ? (
                            <div className="meeting-join-card-body-text-fail">
                                Please use a <span className="meeting-join-card-body-text-fail-highlight">mobile device</span> to join this session.
                            </div>
                        ) : (failsDesktop ? (
                            <div className="meeting-join-card-body-text-fail">
                                Please use a <span className="meeting-join-card-body-text-fail-highlight">desktop device</span> to join this session.
                            </div>
                        ) : (
                            <>{bodyText}</>
                        ))}
                    </div>
                </div>
            </div>
            {changeLink && (
                <div className="meeting-tertiary-link-wrapper">
                    Need to <Link to={changeLink} className="meeting-tertiary-link">make a change?</Link>
                </div>
            )}
        </div>
    );
}

function UpcomingSession(props) {
    return (
        <MeetingCard
            preTitle="Scheduled Mission"
            title={props.missionName}
            date={props.formattedStartTime}
            timeSummaryStart={`Starting in `}
            timeSummaryEnd={props.timeUntilString}
            bodyText="This session opens 10 minutes before the scheduled start time. Please check back then."
            deviceRequirement={props.deviceRequirement}
            requireWalletUsage={props.requireWalletUsage}
            requireShareScreen={props.requireShareScreen}
            requireVideo={props.requireVideo}
            viewUserWallets={props.viewUserWallets}
            changeLink={props.changeLink}
        />
    );
}

function ImminentSession(props) {
    return (
        <MeetingCard
            preTitle="Scheduled Mission"
            title={props.missionName}
            date={props.formattedStartTime}
            timeSummaryStart={`Starting in `}
            timeSummaryEnd={props.timeUntilString}
            bodyText="Click the button to join your scheduled mission if you are not automatically redirected."
            buttonText="Join session"
            buttonAction={() => window.open(props.meetingLink, '_blank')}
            deviceRequirement={props.deviceRequirement}
            requireWalletUsage={props.requireWalletUsage}
            requireShareScreen={props.requireShareScreen}
            requireVideo={props.requireVideo}
            viewUserWallets={props.viewUserWallets}
        />
    );
}

function InProgressSession(props) {
    return (
        <MeetingCard
            preTitle="Scheduled Mission"
            title={props.missionName}
            date={props.formattedStartTime}
            timeSummaryStart="This meeting "
            timeSummaryEnd="has started"
            bodyText="Click the button to join your scheduled mission if you are not automatically redirected."
            buttonText="Join session"
            buttonAction={() => window.open(props.meetingLink, '_blank')}
            deviceRequirement={props.deviceRequirement}
            requireWalletUsage={props.requireWalletUsage}
            requireShareScreen={props.requireShareScreen}
            requireVideo={props.requireVideo}
            viewUserWallets={props.viewUserWallets}
        />
    );
}

function PastSession(props) {
    return (
        <MeetingCard
            preTitle="Scheduled Mission"
            title={props.missionName}
            date={props.formattedStartTime}
            timeSummaryStart="This session is in the past."
        />
    );
}

function NotFoundSession() {
    return (
        <MeetingCard
            preTitle="Scheduled Mission"
            title="Not Found"
            date="N/A"
            timeSummaryStart="This session does not exist."
        />
    );
}

function LoadingSession() {
    return (
        <div className="meeting-join-container">
            <div className="meeting-join-card">
                <CenteredLoadingIcon />
            </div>
        </div>
    );
}

// === drop this near the top of your file ===
function timeUntilHelper(ms) {
    // Ruby: return nil if negative
    if (ms <= 0) return null;

    const second = 1000;
    const minute = 60 * second;
    const hour = 60 * minute;
    const day = 24 * hour;

    let remaining = ms;

    // days = (difference_in_seconds / 1.day).to_i
    const days = Math.floor(remaining / day);
    remaining = remaining % day;

    // hours = ((difference_in_seconds % 1.day) / 1.hour).to_i
    const hours = Math.floor(remaining / hour);
    remaining = remaining % hour;

    // minutes = ((difference_in_seconds % 1.hour) / 1.minute).to_i + 1
    // (Note: this can be 60, matching the Ruby behavior on 59m+ seconds)
    const minutes = Math.floor(remaining / minute) + 1;

    // Build parts like Ruby:
    const parts = [];
    if (days > 0) parts.push(`${days} day${days !== 1 ? "s" : ""}`);
    if (hours > 0 || days > 0) parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
    parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);

    return parts.join(", ");
}

export default JoinMeetingContent;